import Image from "next/image";
import styles from "./Prefit.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import upscbanner1 from "../../assets/images/home/Mob_Banner/Pre-Prefit-Web-Banner.jpg"; 
//import MobPrelimsmain from "../../assets/images/upsc/prestorming/Prefit-2025-B2-Mobile-Banner.jpg";
import Content from "./prefit-content";
import { useEffect } from "react";
import { useRouter } from "next/router"; 
import axios from 'axios';
import AOS from "aos";
import "aos/dist/aos.css";
import Carousel from 'react-bootstrap/Carousel';
import Chennai from "../prefit-chennai/pre-chennai";
import Delhi from "../prefit-chennai/pre-delhi";
import Bengaluru from "../prefit-chennai/pre-bengaluru";
import Trivandrum from "../prefit-chennai/pre-trivandrum";
import Trichy from "../prefit-chennai/pre-trichy";
import Salem from "../prefit-chennai/pre-salem";
import Coimbatore from "../prefit-chennai/pre-coimbatore";
import Madurai from "../prefit-chennai/pre-madurai";
import Online from "../prefit-chennai/pre-online";
import Hyderabad from "../prefit-chennai/pre-hyderabad";
// import Prelims_Form from "./prefit-form";
import dynamic from "next/dynamic";
import Head from "next/head";
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const Prelims = () => {

   const banners = [
        { img: upscbanner1, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
    
      ]
  

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "UPSC Prelims Test Series 2025 | Prefit Test",
    "url": "https://www.shankariasacademy.com/upsc-prefit-test/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Prefit-Web-Banner-without-button.07b8310f.jpg",
    "description": "Join UPSC Prelims Test Series 2025 - Prefit Test by Shankar IAS Academy. Ace your IAS prep with quality daily test series, expert reviews & success tips."
  }

  const router = useRouter();
  
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);
  
  useEffect(() => {
    const handleRouteChange = () => {
      AOS.refresh();
    };
  
    router.events.on("routeChangeComplete", handleRouteChange);
  
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
    
 
  return (
    <>
             <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>UPSC Prelims Test Series 2025 | Prefit Test</title>
                <meta name="title" content="UPSC Prelims Test Series 2025 | Prefit Test" />
                <meta name="description" content="Join UPSC Prelims Test Series 2025 - Prefit Test by Shankar IAS Academy. Ace your IAS prep with quality daily test series, expert reviews & success tips." />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-prefit-prelims-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC Prelims Test Series 2025 | Prefit Test" />
                <meta property="og:description" content="Join UPSC Prelims Test Series 2025 - Prefit Test by Shankar IAS Academy. Ace your IAS prep with quality daily test series, expert reviews & success tips." />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-prefit-prelims-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
                 <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
              </Head>  
                  
              <Navbar title="Prefit" />
      {/* <!-- UPSC Class Online --> */}


       <div className="container">
        <div className="row pt-3">
          <div className="col">
            <h1 className={`${styles.heading3d}`}>
            UPSC Prelims Test Series 2025 | Prefit Test
            </h1>
          </div>
        </div>
      </div>


        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div data-aos="fade-right" className= {`${styles.cardBox} `}>
                  <p className={`${styles.contactheader} text-center`}>Enquiry</p>
                  <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
                  <div class={`${styles.addmissionform} npf_wgts `} data-height="500px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
              </div>
            </div>

            <div className="col-md-6 pt-3">
              <Carousel>
                {banners.map((e, index) =>
                  <Carousel.Item key={index}>
                    <Link href={e.link} rel="noreferrer">
                      <Image
                      className="carouselimage w-100 h-100"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      /> 
                    </Link>
                  </Carousel.Item>
                )}
              </Carousel>
            </div>
          </div>
        </div> 

        <div className="container">
        <div className="row">
          <div className="col pt-2">
            <h2 className={`${styles.sectiontitle} mb-0`}>
               UPSC Prelims Test (Prefit) Centres, Schedule & Enrolment
            </h2>
          </div>
        </div>
        </div>
     
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <div
              className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}
            >
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4 active"
                data-bs-toggle="pill"
                data-bs-target="#centre-1"
                type="button"
                role="tab"
                aria-controls="centre-1"
                aria-selected="true"
              >
                Chennai
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-2"
                type="button"
                role="tab"
                aria-controls="centre-2"
                aria-selected="false"
              >
                Delhi
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-3"
                type="button"
                role="tab"
                aria-controls="centre-3"
                aria-selected="false"
              >
                Bengaluru
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-4"
                type="button"
                role="tab"
                aria-controls="centre-4"
                aria-selected="false"
              >
                Trivandrum
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-5"
                type="button"
                role="tab"
                aria-controls="centre-5"
                aria-selected="false"
              >
                Hyderabad
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-6"
                type="button"
                role="tab"
                aria-controls="centre-6"
                aria-selected="false"
              >
                Trichy
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-7"
                type="button"
                role="tab"
                aria-controls="centre-7"
                aria-selected="false"
              >
                Salem
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-8"
                type="button"
                role="tab"
                aria-controls="centre-8"
                aria-selected="false"
              >
                Coimbatore
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-9"
                type="button"
                role="tab"
                aria-controls="centre-9"
                aria-selected="false"
              >
                Madurai
              </button>

              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-10"
                type="button"
                role="tab"
                aria-controls="centre-10"
                aria-selected="false"
              >
                Online
              </button>
             
            </div>
          </div>
        </div>
      </div>

 {/* <Prelims_Form /> */}

      <div className="tab-content">

<div className="tab-pane active" id="centre-1">
  <Chennai />
</div>

<div className="tab-pane" id="centre-2">
  <Delhi />
</div>

<div className="tab-pane" id="centre-3">
   <Bengaluru />
</div>

<div className="tab-pane" id="centre-4">
  <Trivandrum />  
</div>

<div className="tab-pane" id="centre-5">
  <Hyderabad />  
</div>

<div className="tab-pane" id="centre-6">
  <Trichy />
</div>

<div className="tab-pane" id="centre-7">
  <Salem /> 
</div>

<div className="tab-pane" id="centre-8">
  <Coimbatore />
</div>

<div className="tab-pane" id="centre-9">
  <Madurai /> 
</div>

<div className="tab-pane" id="centre-10">
  <Online /> 
</div>

</div>
    
      <Content />
      <BranchAddress />
      <Footer />
    </>
  );
};

export default Prelims;
